module.exports = __webpack_public_path__ + "static/media/maqam2.7f3f7b22.jpeg";